import React from 'react';
import GeneralComponentErrorShield from '../../../general/GeneralComponentErrorShield';
import useFetchData from '../../../../hooks/useFetchData';
import ExposureVsCumulativeChart from './subComponents/ExposureVsCumulativeChart.component';
import ExposureVsCumulativeTable from './subComponents/ExposureVsCumulativeTable.component';
import {
  activeDateRangeEndSelector,
  activeDateRangeStartSelector,
} from '../../../../redux/pages/selectors';
import { useSelector } from 'react-redux';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import NoDataMessage from '../../../feedback/NoDataMessage.component';

const ExposureVsCumulativeReturns: React.FC<FundInfoComponentProps> = ({
  fundId,
}) => {
  const fromDate = useSelector(activeDateRangeStartSelector);
  const toDate = useSelector(activeDateRangeEndSelector);

  const PerformanceAttributionData = useFetchData({
    url: `/performance_attribution/${fundId}/${fromDate}/${toDate}`,
    keyName: `performance_attribution_${fundId}_${fromDate}_${toDate}`,
    makeFetch:
      fundId !== undefined &&
      fromDate !== null &&
      fromDate !== '' &&
      toDate !== null &&
      toDate !== '',
  });

  // TODO: migrate this config check to the backend. For now the page is only
  // configured when sector_aggregation includes aggregate_pct_gross_exposure.
  const sectors =
    PerformanceAttributionData?.data?.[0]?.sector_aggregation;
  const isConfigured =
    Array.isArray(sectors) &&
    sectors.some(
      (sector: any) => sector?.aggregate_pct_gross_exposure != null,
    );

  return (
    <GeneralComponentErrorShield
      dataObjects={[PerformanceAttributionData]}
      customLoadingMessages={[
        'Loading Performance Attribution Data',
        `${fromDate} to ${toDate}`,
        'Just a few more seconds...',
      ]}
      customErrorMessage="No Data Available."
    >
      {isConfigured ? (
        <>
          <ExposureVsCumulativeChart data={PerformanceAttributionData} />
          <ExposureVsCumulativeTable data={PerformanceAttributionData} />
        </>
      ) : (
        <NoDataMessage message="This page is not configured." />
      )}
    </GeneralComponentErrorShield>
  );
};

export default ExposureVsCumulativeReturns;
